export var ApiKeyType;
(function (ApiKeyType) {
    ApiKeyType["TENANT_SYSTEM_JWT"] = "TENANT_SYSTEM_JWT";
    ApiKeyType["ADMIN_JWT_ACCESS_TOKEN"] = "ADMIN_JWT_ACCESS_TOKEN";
    ApiKeyType["ADMIN_JWT_REFRESH_TOKEN"] = "ADMIN_JWT_REFRESH_TOKEN";
    ApiKeyType["USER_JWT_ACCESS_TOKEN"] = "USER_JWT_ACCESS_TOKEN";
    ApiKeyType["USER_JWT_REFRESH_TOKEN"] = "USER_JWT_REFRESH_TOKEN";
    ApiKeyType["BUSINESS_JWT_ACCESS_TOKEN"] = "BUSINESS_JWT_ACCESS_TOKEN";
    ApiKeyType["BUSINESS_JWT_REFRESH_TOKEN"] = "BUSINESS_JWT_REFRESH_TOKEN";
    ApiKeyType["BLOCKCHAIN_WRITER_JWT"] = "BLOCKCHAIN_WRITER_JWT";
    ApiKeyType["BLOCKCHAIN_READER_JWT"] = "BLOCKCHAIN_READER_JWT";
    ApiKeyType["TRANSACTION_JWT_ACCESS_TOKEN"] = "TRANSACTION_JWT_ACCESS_TOKEN";
    ApiKeyType["WEBHOOK_OUTBOUND_JWT"] = "WEBHOOK_OUTBOUND_JWT";
    /** One-Time Token for passwordless auth flows (magic link, SMS, etc.) */
    ApiKeyType["ONE_TIME_TOKEN"] = "ONE_TIME_TOKEN";
    // TODO: this needs to be removed. However, there is still dependency
    ApiKeyType["TENANT_LEGACY_ADMIN"] = "TENANT_ADMIN_JWT";
    // TENANT_SYSTEM_API_SECRET    = 'TENANT_SYSTEM_API_SECRET',
})(ApiKeyType || (ApiKeyType = {}));
//# sourceMappingURL=api-key-type.enum.js.map